<template>
  <div class="buttons--group">
    <slot />
  </div>
</template>
<script>
export default {
  name: "ButtonsGroup"
};
</script>
<style lang="scss" scoped>
.buttons--group {
  display: flex;
  overflow: auto;
  list-style: none;
  margin-bottom: 2rem;
  a:not(:first-of-type),
  button:not(:first-of-type) {
    border-left: 0;
  }
}
</style>
